module.exports = __webpack_public_path__ + "static/img/Lance-Franklin.e863c9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lance-Franklin.jpg
// module id = rBvd
// module chunks = 0